<template>
	<f7-page
		class="training-action"
		v-if="currentAuditTest && currentAuditTest.audit"
	>
		<BackButton />

		<AuditTestQuiz
			:trainingAction="currentAuditTest"
			:quiz="answerableQuiz"
			:sectionHeaders="sectionHeaders"
			@changeSlideFromQuiz="changeSlide"
			@slideChanged="slideChanged"
			@submit="onSubmitted"
		/>
	</f7-page>
</template>
<script>
	import AuditTestQuiz from "./AuditTestQuiz.vue";
	import { mapGetters } from "vuex";

	export default {
		components: {
			AuditTestQuiz,
		},

		data() {
			return {
				submitted: false,
			};
		},

		mounted() {
			const swiperEl = document.querySelector(".swiper");
			if (swiperEl) this.swiper = swiperEl.swiper;
		},

		unmounted() {
			if (this.submitted) {
				const auditTestId = this.$store.state.app.auditTestId;

				this.$store.commit(
					"app/setAuditTests",
					this.$store.state.app.auditTests.filter((t) => t.id !== auditTestId)
				);

				this.$store.dispatch("app/getDashboard");
			}
		},

		methods: {
			onSubmitted() {
				this.submitted = true;
			},

			changeSlide(where) {
				if (!this.swiper || this.swiper.destroyed) {
					const swiperEl = document.querySelector(".swiper");
					this.swiper = swiperEl ? swiperEl.swiper : null;
				}
				if (!this.swiper) return;

				let direction = where;

				if (typeof where === "number") {
					direction = where >= this.swiper.activeIndex ? "next" : "prev";
					this.swiper.slideTo(where);
				} else if (where === "next") {
					this.swiper.slideTo(this.swiper.activeIndex + 1);
				} else {
					this.swiper.slideTo(this.swiper.activeIndex - 1);
				}

				this.changeActiveMark(this.swiper.activeIndex, direction);
			},

			slideChanged(x) {
				const index = this.swiper ? this.swiper.activeIndex : x;

				document.getElementById(`${index}`)?.classList.add("active");

				if (document.getElementById(`${index - 1}`)) {
					if (!this.currentAuditTest.done) {
						document.getElementById(`${index - 1}`).classList.add("done");
					}
					document.getElementById(`${index - 1}`).classList.remove("active");
				}

				if (document.getElementById(`${index + 1}`)) {
					document.getElementById(`${index + 1}`).classList.remove("active");
				}
			},

			changeActiveMark(x, where = false) {
				document.getElementById(`${x}`)?.classList.add("active");

				if (this.swiper) {
					if (where && where === "next") {
						document.getElementById(`${this.swiper.activeIndex - 1}`)?.classList.remove("active");
					} else {
						document.getElementById(`${this.swiper.activeIndex + 1}`)?.classList.remove("active");
					}
				} else {
					document.getElementById(`${x - 1}`)?.classList.remove("active");
				}
			},
		},

		computed: {
			...mapGetters("app", ["currentAuditTest"]),

			answerableQuiz() {
				const audit = this.currentAuditTest.audit;

				return {
					...audit,
					questions: (audit.questions || []).filter((q) => q.type !== 9),
				};
			},

			sectionHeaders() {
				const questions = [...(this.currentAuditTest.audit.questions || [])].sort(
					(a, b) => a.priority - b.priority || a.id - b.id
				);

				const map = {};
				let currentHeader = null;

				for (const question of questions) {
					if (question.type === 9) {
						currentHeader = question.question;
						continue;
					}

					map[question.id] = currentHeader;
				}

				return map;
			},
		},
	};
</script>
